// extracted by mini-css-extract-plugin
export default {"commandsPanel":"ExportDocumentToolsCommandsPanel_commandsPanel__Q9xqO"};